import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/* Shared visual chrome for the auth pages (login, forgot, reset, verify).
   Same recipe as LoginPage / LandingPage hero. */

export function HeroBg() {
  return (
    <>
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          backgroundImage: "url(/hero.webp)",
          backgroundSize: "cover",
          backgroundPosition: "center 30%",
          filter: "grayscale(1) brightness(0.38) contrast(1.18)",
        }}
      />
      <div
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,14,20,0.78) 0%, rgba(10,14,20,0.92) 50%, var(--bg-base) 100%)",
        }}
      />
    </>
  );
}

export function Wordmark({ size }: { size: "md" | "lg" }) {
  const cls = size === "lg" ? "text-[44px] sm:text-[56px]" : "text-[32px]";
  return (
    <span className={`block font-black tracking-tight leading-none text-fg-primary ${cls}`}>
      <span className="text-accent">S</span>torica
    </span>
  );
}

export function BackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-1.5 text-[13px] text-fg-muted hover:text-fg-primary transition-colors"
    >
      <ArrowLeft size={14} />
      {label}
    </Link>
  );
}

/* Card shell: centered column with hero, back link, wordmark, then children. */
export function AuthShell({
  backTo,
  backLabel,
  children,
}: {
  backTo: string;
  backLabel: string;
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-[100svh] flex flex-col items-center px-5 py-8 relative">
      <HeroBg />
      <div className="w-full max-w-sm relative z-10">
        <BackLink to={backTo} label={backLabel} />
        <div className="text-center my-8">
          <Wordmark size="md" />
        </div>
        {children}
      </div>
      <div className="flex-1 min-h-[20px]" />
    </div>
  );
}
